import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpStatus } from '@core/classes/http-status.class';

import * as Objects from '@core/objects';
import { VersionFeedback, ShareVersionFeedback } from '@core/models/version-feedback';
import { VersionShare, UploadVersionShare } from '@core/models/version-share.model';
import * as Access from '@app/models/access';

export enum VersionsActionType {

	// EVENT CALLS
	LoadVersion = "[Versions] GET - Obtain a version by id",
	LoadVersionSuccess = "[Versions] GET - Obtain a version by id SUCCESS",
	LoadVersionError = "[Versions] GET - Obtain a version by id ERROR",

	LoadRelatedVersions = "[Versions] GET - Obtain a related versions by link",
	LoadRelatedVersionsSuccess = "[Versions] GET - Obtain a related versions by link SUCCESS",
	LoadRelatedVersionsError = "[Versions] GET - Obtain a related version by link ERROR",

    LoadVersionFiles = "[Versions] GET - Obtain a version files",
    LoadVersionFilesSuccess = "[Versions] GET - Obtain a version files SUCCESS",
    LoadVersionFilesError = "[Versions] GET - Obtain a version files ERROR",

    LoadVersionComments = "[Versions] GET - Obtain a version messages with context",
    LoadVersionCommentsSuccess = "[Versions] GET - Obtain a version messages with context SUCCESS",
    LoadVersionCommentsError = "[Versions] GET - Obtain a version messages with context ERROR",

    LoadVersionFeedbacks = "[Versions] GET - Obtain a version feedbacks",
    LoadVersionFeedbacksSuccess = "[Versions] GET - Obtain a version feedbacks SUCCESS",
    LoadVersionFeedbacksPreSuccess = "[Versions] dispatch versions pre processed feedbacks - GET PRE SUCCESS",
    LoadVersionFeedbacksError = "[Versions] GET - Obtain a version feedbacks ERROR",

    ArchiveVersionFeedback = "[Versions] PUT - Archive version feedback for one user",
    ArchiveVersionFeedbackSuccess = "[Versions] PUT - Archive version feedback for one user SUCCESS",
    ArchiveVersionFeedbackError = "[Versions] PUT - Archive version feedback for one user ERROR",
    // LoadVersionFeedbackNotes = "[Versions] GET - Obtain version feedback notes for feedback files",
    
    LoadVersionShares = "[Versions] GET - Obtain a version shares",
    LoadVersionSharesSuccess = "[Versions] GET - Obtain a version shares SUCCESS",
    // LoadVersionSharesPreSuccess = "[Versions] dispatch versions pre processed shares - GET PRE SUCCESS",
    LoadVersionSharesError = "[Versions] GET - Obtain a version shares ERROR",

    ArchiveVersionShare = "[Versions] PUT - Archive version share for one token ",
    ArchiveVersionShareSuccess = "[Versions] PUT - Archive version share for one token SUCCESS",
    ArchiveVersionShareError = "[Versions] PUT - Archive version share for one token ERROR",
    
    ResetVersionShare = "[Versions] PUT - RESET version share for one token ",
    ResetVersionShareSuccess = "[Versions] PUT - RESET version share for one token SUCCESS",
    ResetVersionShareError = "[Versions] PUT - RESET version share for one token ERROR",

    LoadVersionFeedbackNotesCounter = "[Versions] GET - Obtain version feedback notes counter for all version files",
    LoadVersionFeedbackNotesCounterSuccess = "[Versions] GET - Obtain version feedback notes counter for all version files SUCCESS",
    LoadVersionFeedbackNotesCounterError = "[Versions] GET - Obtain version feedback notes counter for all version files ERROR",

    // LoadVersionFeedbackFileNotes = "[Versions] GET - Obtain version feedback notes for a file",
    // LoadVersionFeedbackFileNotesSuccess = "[Versions] GET - Obtain version files feedback notes for a file SUCCESS",
    // LoadVersionFeedbackFileNotesError = "[Versions] GET - Obtain version files feedback notes for a file ERROR",

    LoadShareFeedback = "[Versions] GET - Obtain the share feedback for this version and user",
    LoadShareFeedbackSuccess = "[Versions] GET - Obtain the share feedback for this version and user SUCCESS",
    LoadShareFeedbackError = "[Versions] GET - Obtain the share feedback for this version and user ERROR",

    LoadVersionProject = "[Versions] GET - Obtain a version project",
    LoadVersionProjectSuccess = "[Versions] GET - Obtain a version project SUCCESS",
    LoadVersionProjectError = "[Versions] GET - Obtain a version project ERROR",

    SetVersionStatus = "[Versions] PUT - Set version status",
    SetVersionStatusSuccess = "[Versions] PUT - Set version status SUCCESS",
    SetVersionStatusError = "[Versions] PUT - Set version status ERROR",

    SetVersionLabels = "[Versions] PUT - Set labels in version",
    SetVersionLabelsSuccess = "[Versions] PUT - Set labels in version SUCCESS",
    SetVersionLabelsError = "[Versions] PUT - Set labels in version ERROR",

    LoadEditorAccess = "[Versions - Editor] GET - Obtain access",
    LoadEditorAccessSuccess = "[Versions - Editor] GET - Obtain access SUCCESS",
    LoadEditorAccessError = "[Versions - Editor] GET - Obtain access ERROR",

    // LoadVersionHeader = "[Versions] GET - Obtain a Version header by id",
	LoadPartialVersionSuccess = "[Versions] Obtain a partial Version by id when no access SUCCESS",
	// LoadVersionHeaderError = "[Versions] Obtain a Version header by id ERROR",

    UpdateVersion = "[Versions] Update version by id",
    UpdateVersionMessages = "[Versions] - Update version messages by id from WS event",
    // UpdateVersionFeedbacks = "[Versions] - Update version feedbacks by id from WS event",
    UpdateVersionShares = "[Versions] - Update version shares by version id from WS event",

    LoadUploadVersionShares = "[Versions] GET - Obtain the  upload-version shares for current token",
    LoadUploadVersionSharesSuccess = "[Versions] GET - Obtain the  upload-version shares for current token SUCCESS",
    LoadUploadVersionSharesError = "[Versions] GET - Obtain the  upload-version shares for current token ERROR",

    LoadUploadedVersion = "[Versions] GET - Obtain the uploaded upload-version based in access for messages",
    LoadUploadedVersionSuccess = "[Versions] GET - Obtain the uploaded upload-version  based in access for messages SUCCESS",
    LoadUploadedVersionError = "[Versions] GET - Obtain the uploaded upload-version  based in access for messages ERROR",

    SendUploadVersionFiles = '[Versions] Submit new version for upload-version share POST',
    SendUploadVersionFilesSuccess = '[Versions] Submit new version for upload-version share SUCCESS',
    SendUploadVersionFilesError = '[Versions] Submit new version for upload-version share ERROR',

    SendSelfShareFeedbackRequest = '[Versions - Feedback] Submit self feedback request POST',
    SendSelfShareFeedbackRequestSuccess = '[Versions - Feedback] Submit self feedback request SUCCESS ',
    SendSelfShareFeedbackRequestError = '[Versions - Feedback] Submit self feedback request ERROR',

    Clear = "[Versions] clear data",
    ClearFiles = "[Versions] clear files",

    ResetArchiveActionStatus = "[Versions] Reset action status for version share archive action",
    ResetResetActionStatus = "[Versions] Reset action status for version share reset action",
    ResetUploadVersionFilesActionStatus = "[Versions] Reset action status for upload version share upload files action",
    ResetSelfShareFeedbackRequestActionStatus = '[Versions - Feedback]Reset action status for send self feedback request action',

}

// Load Available Events
export class LoadVersion implements Action {
    readonly type = VersionsActionType.LoadVersion;
    constructor(public versionId: number) {}
}

export class LoadVersionSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionSuccess;
    constructor(public version: Objects.Version) {}
}

export class LoadVersionError implements Action {
    readonly type = VersionsActionType.LoadVersionError;
    constructor(public versionId: number, public error: HttpErrorResponse) {}
}

export class LoadRelatedVersions implements Action {
    readonly type = VersionsActionType.LoadRelatedVersions;
    constructor(public link: string) {}
}
export class LoadRelatedVersionsSuccess implements Action {
    readonly type = VersionsActionType.LoadRelatedVersionsSuccess;
    constructor(public versions: Objects.Version[]) {}
}

export class LoadRelatedVersionsError implements Action {
    readonly type = VersionsActionType.LoadRelatedVersionsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadVersionFiles implements Action {
    readonly type = VersionsActionType.LoadVersionFiles;
    constructor() {}
}

export class LoadVersionFilesSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionFilesSuccess;
    constructor(public files: Array<Objects.File>) {}
}

export class LoadVersionFilesError implements Action {
    readonly type = VersionsActionType.LoadVersionFilesError;
    constructor(public error: HttpErrorResponse) {}
}

// this shouldn't be an effect, because of access 
// export class LoadVersionFeedbackNotes implements Action {
//     readonly type = VersionsActionType.LoadVersionFeedbackNotes;
//     constructor(public files: Array<Objects.File>) {}
// }

export class LoadVersionFeedbackNotesCounter implements Action {
    readonly type = VersionsActionType.LoadVersionFeedbackNotesCounter;
    constructor() {}
}

export class LoadVersionFeedbackNotesCounterSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionFeedbackNotesCounterSuccess;
    constructor( public counter: Array<Objects.AnnotationsCounter>) {}
}

export class LoadVersionFeedbackNotesCounterError implements Action {
    readonly type = VersionsActionType.LoadVersionFeedbackNotesCounterError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadVersionFeedbacks implements Action {
    readonly type = VersionsActionType.LoadVersionFeedbacks;
    constructor() {}
}

export class LoadVersionFeedbacksPreSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionFeedbacksPreSuccess;
    constructor(public feedbacks: Array<VersionFeedback>) {}
}

export class LoadVersionFeedbacksSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionFeedbacksSuccess;
    constructor(public feedbacks: Array<VersionFeedback>) {}
}

export class LoadVersionFeedbacksError implements Action {
    readonly type = VersionsActionType.LoadVersionFeedbacksError;
    constructor(public error: HttpErrorResponse) {}
}

export class ArchiveVersionFeedback implements Action {
    readonly type = VersionsActionType.ArchiveVersionFeedback;
    constructor(public feedback: VersionFeedback) {}
}

export class ArchiveVersionFeedbackSuccess implements Action {
    readonly type = VersionsActionType.ArchiveVersionFeedbackSuccess;
    constructor(public feedback: VersionFeedback) {}
}

export class ArchiveVersionFeedbackError implements Action {
    readonly type = VersionsActionType.ArchiveVersionFeedbackError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadVersionShares implements Action {
    readonly type = VersionsActionType.LoadVersionShares;
    constructor() {}
}

// export class LoadVersionSharesPreSuccess implements Action {
//     readonly type = VersionsActionType.LoadVersionSharesPreSuccess;
//     constructor(public shares: Array<VersionShare>) {}
// }

export class LoadVersionSharesSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionSharesSuccess;
    constructor(public shares: Array<VersionShare>, public version: Objects.Version) {}
}

export class LoadVersionSharesError implements Action {
    readonly type = VersionsActionType.LoadVersionSharesError;
    constructor(public error: HttpErrorResponse) {}
}

export class ArchiveVersionShare implements Action {
    readonly type = VersionsActionType.ArchiveVersionShare;
    constructor(public share: VersionShare, public dispatcherKey: string) {}
}

export class ArchiveVersionShareSuccess implements Action {
    readonly type = VersionsActionType.ArchiveVersionShareSuccess;
    constructor(public share: VersionShare) {}
}

export class ArchiveVersionShareError implements Action {
    readonly type = VersionsActionType.ArchiveVersionShareError;
    constructor(public error: HttpErrorResponse) {}
}

export class ResetVersionShare implements Action {
    readonly type = VersionsActionType.ResetVersionShare;
    constructor(public share: VersionShare, public dispatcherKey: string) {}
}

export class ResetVersionShareSuccess implements Action {
    readonly type = VersionsActionType.ResetVersionShareSuccess;
    constructor(public share: VersionShare) {}
}

export class ResetVersionShareError implements Action {
    readonly type = VersionsActionType.ResetVersionShareError;
    constructor(public error: HttpErrorResponse) {}
}


export class LoadShareFeedback implements Action {
    readonly type = VersionsActionType.LoadShareFeedback;
    constructor(public user: Objects.User) {}
}

export class LoadShareFeedbackSuccess implements Action {
    readonly type = VersionsActionType.LoadShareFeedbackSuccess;
    constructor(public version: Objects.Version, public shareFeedbacks: ShareVersionFeedback[]) {}
}

export class LoadShareFeedbackError implements Action {
    readonly type = VersionsActionType.LoadShareFeedbackError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadVersionProject implements Action {
    readonly type = VersionsActionType.LoadVersionProject;
    constructor() {}
}

export class LoadVersionProjectSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionProjectSuccess;
    constructor(public project: Objects.Request) {}
}

export class LoadVersionProjectError implements Action {
    readonly type = VersionsActionType.LoadVersionProjectError;
    constructor(public error: HttpErrorResponse) {}
}

export class SetVersionStatus implements Action {
    readonly type = VersionsActionType.SetVersionStatus;
    constructor(public status: Objects.Status) {}
}

export class SetVersionStatusSuccess implements Action {
    readonly type = VersionsActionType.SetVersionStatusSuccess;
    constructor(public version: Objects.Version) {}
}

export class SetVersionStatusError implements Action {
    readonly type = VersionsActionType.SetVersionStatusError;
    constructor(public error: HttpErrorResponse) {}
}

export class Clear implements Action {
    readonly type = VersionsActionType.Clear;
    constructor() {}
}

export class ClearFiles implements Action {
    readonly type = VersionsActionType.ClearFiles;
    constructor() {}
}

export class LoadEditorAccess implements Action {
    readonly type = VersionsActionType.LoadEditorAccess;
    constructor() {}
}

export class LoadEditorAccessSuccess implements Action {
    readonly type = VersionsActionType.LoadEditorAccessSuccess;
    constructor(public access: Access.AccessVersion) {}
}

export class LoadEditorAccessError implements Action {
    readonly type = VersionsActionType.LoadEditorAccessError;
    constructor(public error: HttpErrorResponse) {}
}


export class SetVersionLabels implements Action {
    readonly type = VersionsActionType.SetVersionLabels;
    constructor(public labels: Array<Objects.Label>) {}
}

export class SetVersionLabelsSuccess implements Action {
    readonly type = VersionsActionType.SetVersionLabelsSuccess;
    constructor(public version: Objects.Version) {}
}

export class SetVersionLabelsError implements Action {
    readonly type = VersionsActionType.SetVersionLabelsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadVersionComments implements Action {
    readonly type = VersionsActionType.LoadVersionComments;
    constructor() {}
}

export class LoadVersionCommentsSuccess implements Action {
    readonly type = VersionsActionType.LoadVersionCommentsSuccess;
    constructor(public versionComments: Array<Objects.VersionMessage>) {}
}

export class LoadVersionCommentsError implements Action {
    readonly type = VersionsActionType.LoadVersionCommentsError;
    constructor(public error: HttpErrorResponse) {}
}

// export class LoadVersionHeader implements Action {
//     readonly type = VersionsActionType.LoadVersionHeader;
//     constructor(public versionId: number) {}
// }
export class LoadPartialVersionSuccess implements Action {
    readonly type = VersionsActionType.LoadPartialVersionSuccess;
    constructor(public version: Objects.Version) {}
}

// export class LoadVersionHeaderError implements Action {
//     readonly type = VersionsActionType.LoadVersionHeaderError;
//     constructor(public error: HttpErrorResponse) {}
// }

export class UpdateVersion implements Action {
    readonly type = VersionsActionType.UpdateVersion;
    constructor(public versionId: number) {}
}

export class UpdateVersionMessages implements Action {
    readonly type = VersionsActionType.UpdateVersionMessages;
    constructor(public versionId: number) {}
}

// export class UpdateVersionFeedbacks implements Action {
//     readonly type = VersionsActionType.UpdateVersionFeedbacks;
//     constructor(public versionId: number, public user: Objects.User) {}
// }

export class UpdateVersionShares implements Action {
    readonly type = VersionsActionType.UpdateVersionShares;
    constructor(public versionId: number, public user: Objects.User) {}
}

export class ResetArchiveActionStatus implements Action {
    readonly type = VersionsActionType.ResetArchiveActionStatus;
    constructor() {}
}

export class ResetResetActionStatus implements Action {
    readonly type = VersionsActionType.ResetResetActionStatus;
    constructor() {}
}

export class ResetUploadVersionFilesActionStatus implements Action {
    readonly type = VersionsActionType.ResetUploadVersionFilesActionStatus;
    constructor() {}
}

// to upload  new share version
export class SendUploadVersionFiles implements Action {
    readonly type = VersionsActionType.SendUploadVersionFiles;
    constructor(public token: string, public files: Array<string>) {}
}

export class SendUploadVersionFilesSuccess implements Action {
    readonly type = VersionsActionType.SendUploadVersionFilesSuccess;
    constructor() {}
}

export class SendUploadVersionFilesError implements Action {
    readonly type = VersionsActionType.SendUploadVersionFilesError;
    constructor(public error: HttpErrorResponse) {}
}


// to request self feedback or approval
export class SendSelfShareFeedbackRequest implements Action {
    readonly type = VersionsActionType.SendSelfShareFeedbackRequest;
    constructor(public options: any) {}
}

export class SendSelfShareFeedbackRequestSuccess implements Action {
    readonly type = VersionsActionType.SendSelfShareFeedbackRequestSuccess;
    constructor() {}
}

export class SendSelfShareFeedbackRequestError implements Action {
    readonly type = VersionsActionType.SendSelfShareFeedbackRequestError;
    constructor(public error: HttpErrorResponse) {}
}

export class ResetSelfShareFeedbackRequestActionStatus implements Action {
    readonly type = VersionsActionType.ResetSelfShareFeedbackRequestActionStatus;
    constructor() {}
}


// optional context to decide either is user upload version shares or the bunch calls
export class LoadUploadVersionShares implements Action {
    readonly type = VersionsActionType.LoadUploadVersionShares;
    constructor(public token: string, public context?: string) {}
}
export class LoadUploadVersionSharesSuccess implements Action {
    readonly type = VersionsActionType.LoadUploadVersionSharesSuccess;
    constructor(public versionShares: UploadVersionShare[], public context?: string) {}
}

export class LoadUploadVersionSharesError implements Action {
    readonly type = VersionsActionType.LoadUploadVersionSharesError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadUploadedVersion implements Action {
    readonly type = VersionsActionType.LoadUploadedVersion;
    constructor(public versionId: number) {}
}
export class LoadUploadedVersionSuccess implements Action {
    readonly type = VersionsActionType.LoadUploadedVersionSuccess;
    constructor(public version: Objects.Version) {}
}

export class LoadUploadedVersionError implements Action {
    readonly type = VersionsActionType.LoadUploadedVersionError;
    constructor(public versionId: number, public error: HttpErrorResponse) {}
}

export type VersionsActions = 	LoadVersion |
                                LoadVersionSuccess |
								LoadVersionError |
                                LoadVersionFiles |
                                LoadVersionFilesSuccess | 
                                LoadVersionFilesError |

                                // LoadVersionFeedbackNotes |

                                LoadVersionFeedbackNotesCounter |
                                LoadVersionFeedbackNotesCounterSuccess |
                                LoadVersionFeedbackNotesCounterError |

                                LoadShareFeedback |
                                LoadShareFeedbackSuccess |
                                LoadShareFeedbackError |

                                LoadRelatedVersions |
                                LoadRelatedVersionsSuccess |
								LoadRelatedVersionsError |

                                LoadVersionProject |
                                LoadVersionProjectSuccess |
                                LoadVersionProjectError |

                                LoadVersionFeedbacks |
                                LoadVersionFeedbacksPreSuccess |
                                LoadVersionFeedbacksSuccess |
                                LoadVersionFeedbacksError |

                                ArchiveVersionFeedback |
                                ArchiveVersionFeedbackSuccess |
                                ArchiveVersionFeedbackError |

                                LoadVersionShares |
                                // LoadVersionSharesPreSuccess |
                                LoadVersionSharesSuccess |
                                LoadVersionSharesError |

                                ArchiveVersionShare |
                                ArchiveVersionShareSuccess |
                                ArchiveVersionShareError |

                                ResetVersionShare |
                                ResetVersionShareSuccess |
                                ResetVersionShareError |
                        
                                LoadEditorAccess |
                                LoadEditorAccessSuccess |
                                LoadEditorAccessError | 
                                
                                SetVersionStatus |
                                SetVersionStatusSuccess |
                                SetVersionStatusError |

                                SetVersionLabels |
                                SetVersionLabelsSuccess |
                                SetVersionLabelsError |

                                LoadVersionComments |
                                LoadVersionCommentsSuccess |
                                LoadVersionCommentsError |

                                // LoadVersionHeader |
                                LoadPartialVersionSuccess |
                                // LoadVersionHeaderError | 

                                UpdateVersion | 
                                UpdateVersionMessages |
                                // UpdateVersionFeedbacks |
                                UpdateVersionShares |

                                LoadUploadVersionShares |
                                LoadUploadVersionSharesSuccess |
                                LoadUploadVersionSharesError |

                                LoadUploadedVersion |
                                LoadUploadedVersionSuccess |
                                LoadUploadedVersionError |

                                SendUploadVersionFiles |
                                SendUploadVersionFilesSuccess |
                                SendUploadVersionFilesError |

                                SendSelfShareFeedbackRequest |
                                SendSelfShareFeedbackRequestSuccess |
                                SendSelfShareFeedbackRequestError |
                                ResetSelfShareFeedbackRequestActionStatus |

                                Clear |
                                ClearFiles |

                                ResetArchiveActionStatus |
                                ResetResetActionStatus |
                                ResetUploadVersionFilesActionStatus
                                ;
